/* eslint-disable no-dupe-keys */
import MomentUtils from '@date-io/moment'
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  LinearProgress,
  MenuItem,
  MenuList,
  makeStyles
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import clsx from 'clsx'
import debounce from 'lodash.debounce'
import moment from 'moment'
import React, { useContext, useEffect, useRef, useState } from 'react'
import RTE from 'react-rte'
import stripHtml from 'string-strip-html'
import uuid from 'uuid'

import ToastMessages from '../../components/ToastMessages'
import { addOrEditVoucher, getSearch } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'

import Context from '../../context'
import history from '../../services/history'

import CreateFileS3 from '../../services/CreateFileS3'
import ImageUploadToS3 from '../../services/ImageUpload'

const { REACT_APP_IMAGES_URL } = process.env

function VoucherForm(props) {
  const { setUser, setAboutCurrentPage, setShowLoadingModal, setOpenToast } = useContext(Context)
  const { voucherToEdit } = props.location.state || {}

  const couponsBookShape = {
    offer: '',
    userLimit: 1,
    hasMany: 1,
    activationType: 1,
    expirationTime: 24,
    ctaText: '',
    ctaLink: '',
    launchDate: moment().format('YYYY-MM-DD'),
    shouldAppearOnLP: 0,
    rules: RTE.createEmptyValue()
  }

  const [data, setData] = useState({
    id: voucherToEdit?.id,
    image: voucherToEdit?.image,
    title: voucherToEdit?.title || '',
    partner: voucherToEdit?.partner,
    csv: voucherToEdit?.csv || '',
    type: voucherToEdit?.type || 1,
    random: voucherToEdit?.random || 0,
    code: voucherToEdit?.code || '',
    couponsCode: [],
    description: voucherToEdit
      ? RTE.createValueFromString(voucherToEdit.description, 'html')
      : RTE.createEmptyValue(),
    hasMany: voucherToEdit?.hasMany || '',
    value: voucherToEdit?.value || 0,
    image: voucherToEdit?.image || '',
    validDate: voucherToEdit?.validDate || moment().add(7, 'days').format('YYYY-MM-DD'),
    shouldAppearOnLP: voucherToEdit?.CouponsBookOffers?.findIndex(book => book.shouldAppearOnLP),
    couponsBook: voucherToEdit?.CouponsBookOffers?.map(book => ({
      ...book,
      id: undefined,
      offer: String(book.offer || couponsBookShape.offer),
      ctaText: String(book.ctaText || couponsBookShape.ctaText),
      ctaLink: String(book.ctaLink || couponsBookShape.ctaLink),
      launchDate: String(book.launchDate || couponsBookShape.launchDate),
      rules: RTE.createValueFromString(book.rules || '', 'html')
    })) || [{ ...couponsBookShape }]
  })

  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState(null)
  const [shouldExclude, setShouldExclude] = useState(false)

  const [loadingCSV, setLoadingCSV] = useState(false)
  const [CSV, setCSV] = useState(null)

  const [partners, setPartners] = useState({
    data: [],
    loading: false,
    query: voucherToEdit?.Partner?.fantasyName || '',
    chosen: null,
    showOptions: false
  })

  const searchPartners = useRef(
    debounce(async query => {
      if (query.trim().length < 4) return

      setPartnersInfo({ loading: true })
      const data = await getSearch('partner', query)
      setPartnersInfo({
        data,
        loading: false
      })
    }, 350)
  ).current

  const classes = useStyles()

  const hasManyType1 = (CSV?.length || 0) + data.couponsCode.length

  useEffect(() => {
    if (!isAuthenticated) return history.replace('/')

    setUser(getLoggedUser)
    setAboutCurrentPage({
      title: voucherToEdit ? 'Editar cupom' : 'Novo cupom'
    })

    if (data.csv) getCSV()
  }, [])

  const setDataIfPossible = param => !loading && setData(data => ({ ...data, ...param }))

  const setPartnersInfo = param => setPartners(partners => ({ ...partners, ...param }))

  const getCSV = async () => {
    try {
      setLoadingCSV(true)
      setShowLoadingModal(true)
      const CSV = await fetch(data.csv).then(res => res.text())
      setCSV(CSV.split(/[\r\n]+/g))
      setLoadingCSV(false)
      setShowLoadingModal(false)
    } catch {
      setOpenToast({
        open: true,
        message: 'Houve algum problema ao carregar CSV.',
        type: 'error'
      })
      setTimeout(history.goBack, 1500)
    }
  }

  const hideErrorsModal = () => setErrors(null)
  const showExcludeModal = () => setShouldExclude(true)
  const hideExcludeModal = () => setShouldExclude(false)

  const getPartners = query => {
    setPartnersInfo({ query })
    searchPartners(query)
  }

  const selectPartner = partner => {
    setPartnersInfo({
      showOptions: false,
      query: partner.fantasyName,
      chosen: partner
    })
    setDataIfPossible({
      partner: partner.id
    })
  }

  const addCouponBook = () =>
    setDataIfPossible({
      couponsBook: [...data.couponsBook, { ...couponsBookShape }]
    })

  const excludeCouponBook = qIndex => {
    const couponsBook = [...data.couponsBook].filter((_, index) => index !== qIndex)
    setDataIfPossible({ couponsBook })
  }

  const setCouponBookField = (index, key, value) => {
    const couponsBook = [...data.couponsBook]
    couponsBook[index][key] = value
    setDataIfPossible({ couponsBook })
  }

  const setCouponsCode = file => {
    if (!file) return

    if (!/\.csv$/.test(file.name))
      return setOpenToast({
        open: true,
        message: 'Arquivo selecionado inválido (somente CSV é válido).',
        type: 'error'
      })

    const fr = new FileReader()
    fr.onload = () => {
      const vouchers = fr.result.split(/[\r\n]+/g)
      if (
        CSV?.every(code => !vouchers.includes(code)) &&
        vouchers.every(code1 => vouchers.filter(code2 => code1 === code2).length === 1)
      )
        return setDataIfPossible({
          couponsCode: vouchers
        })

      setOpenToast({
        open: true,
        message: 'Arquivo selecionado contém cupons repetidos.',
        type: 'error'
      })
    }
    fr.readAsText(file)
  }

  const sum = array => array.reduce((accumulative, current) => accumulative + current, 0)

  const checkErrors = () => {
    const errors = []
    // title
    if (!data.title.trim()) errors.push('Sem título')
    // partner
    if (!data.partner) errors.push('Sem parceiro')
    // description
    if (!stripHtml(data.description.toString('html')).trim()) errors.push('Sem descrição')
    // value
    if (data.value === 0) errors.push('Valor precisa ser maior que zero')
    // has many
    if (data.type === 1 && data.random === 1 && !data.hasMany)
      errors.push('Sem quantidade disponível')
    else if (data.type === 2 && !data.hasMany) errors.push('Sem quantidade disponível')
    else if (data.type === 1 && data.random === 1 && data.hasMany < voucherToEdit?.hasMany)
      errors.push('Quantidade disponível menor do que a anterior')
    else if (data.type === 2 && data.hasMany < voucherToEdit?.hasMany)
      errors.push('Quantidade disponível menor do que a anterior')
    else if (
      (data.type === 1 && data.random === 0 ? hasManyType1 : data.hasMany) <
      sum(data.couponsBook.map(item => item.hasMany))
    )
      errors.push('Quantidade disponível menor do que estoques de ofertas')
    else if (data.type === 2 && voucherToEdit && data.hasMany < voucherToEdit.hasMany)
      errors.push('Quantidade disponível menor do que a anterior')
    // coupon codes
    if (data.type === 1 && data.random === 0 && !voucherToEdit && data.couponsCode.length === 0)
      errors.push('Sem lista de cupons')
    // code
    if (data.type === 2 && !data.code.trim()) errors.push('Sem código')
    // image
    if (!data.image) errors.push('Sem imagem destacada')
    else if (
      data.image instanceof File &&
      !['image/jpeg', 'image/png', 'image/gif'].includes(data.image.type)
    )
      errors.push('Tipo de imagem destacada inválido')
    // coupon book offer
    if (data.couponsBook.filter(({ offer }) => !offer.trim()).length > 1)
      errors.push('Alguma oferta associada não definida')
    else if (
      data.couponsBook.filter((book1, index1) =>
        data.couponsBook.some(
          (book2, index2) => book1.offer.trim() === book2.offer.trim() && index1 !== index2
        )
      ).length > 0
    )
      errors.push('Alguma oferta associada repetida')
    // coupon book has many
    if (data.couponsBook.some(({ hasMany }) => !hasMany))
      errors.push('Alguma oferta associada sem estoque')
    else if (
      data.couponsBook.some(
        (book, index) => book.hasMany < (voucherToEdit?.CouponsBookOffers || [])[index]?.hasMany
      )
    )
      errors.push('Alguma oferta associada com estoque menor do que anteriormente')
    else if (
      (data.type === 1 && data.random === 0 ? hasManyType1 : data.hasMany) >
      sum(data.couponsBook.map(book => book.hasMany))
    )
      errors.push('Estoques de ofertas associadas menor do que quantidade disponível')
    // coupon book activation type
    if (data.couponsBook.some(({ offer, activationType }) => !offer.trim() && activationType === 1))
      errors.push('Oferta geral com tipo de ativação inválido')
    // coupon book expiration time
    if (
      data.couponsBook.some(
        ({ expirationTime, activationType }) => activationType === 2 && expirationTime === 0
      )
    )
      errors.push('Alguma oferta com tempo de expiração inválida')
    else if (
      data.couponsBook.some(
        (book, index) =>
          book.expirationTime < (voucherToEdit?.CouponsBookOffers || [])[index]?.expirationTime
      )
    )
      errors.push('Alguma oferta associada com tempo de expiração menor do que anteriormente')
    // coupon book user limit
    if (
      data.couponsBook.some(
        (book, index) => book.userLimit < (voucherToEdit?.CouponsBookOffers || [])[index]?.userLimit
      )
    )
      errors.push('Alguma oferta associada com limite por usuário menor do que anteriormente')
    else if (data.couponsBook.some(book => book.userLimit === 0))
      errors.push('Alguma oferta associada com limite por usuário igual a zero')
    // coupon book cta text
    if (data.couponsBook.some(book => !book.ctaText.trim()))
      errors.push('Alguma oferta associada sem texto de CTA')
    // coupon book cta link
    if (data.couponsBook.some(book => !book.ctaLink.trim()))
      errors.push('Alguma oferta associada sem link de CTA')
    // coupon book launch date
    if (
      data.couponsBook.some(book =>
        moment(book.launchDate).add(1, 'day').isAfter(data.validDate, 'day')
      )
    )
      errors.push('Alguma oferta associada com data de lançamento posterior à data de validade')
    // rules
    if (data.couponsBook.some(book => !stripHtml(book.rules.toString('html')).trim()))
      errors.push('Alguma oferta associada sem regras de uso')

    return !!errors.length && errors
  }

  const generateRandomCodes = (codesToAdd, firstLetter, existingCodes, newCodes = []) => {
    let codes = [
      ...new Set(
        [...new Array(codesToAdd)].map(() =>
          (firstLetter + Math.random().toString(36).substr(-8)).toUpperCase()
        )
      )
    ].filter(code => !existingCodes.includes(code))
    let finalCodes = [newCodes, codes].flat()
    if (codes.length < codesToAdd)
      return generateRandomCodes(
        codesToAdd - codes.length,
        firstLetter,
        [finalCodes, existingCodes].flat(),
        finalCodes
      )
    else return finalCodes
  }

  const uploadCouponsCode = async couponsCode => {
    const finalData = [...(CSV || []), ...(couponsCode || data.couponsCode)].join('\n')
    const fileName = (voucherToEdit?.csv?.match(/[^\/]*?$/) || [])[0] || `${uuid.v4()}.csv`
    const { path } = await CreateFileS3({
      data: finalData,
      fileName,
      path: 'voucher/csv',
      contentType: 'text/csv',
      bucket: process.env.NODE_ENV === 'production' ? 'gdp-prd-clube' : 'gdp-dev-clube'
    })
    return REACT_APP_IMAGES_URL + path
  }

  const save = async situation => {
    const errors = checkErrors()
    if (errors) {
      setErrors(errors)
      return
    }

    setLoading(true)
    setShowLoadingModal(true)

    const hasMany = {
      1: {
        0: hasManyType1,
        1: data.hasMany
      }[data.random],
      2: data.hasMany
    }[data.type]
    const codesToAdd = hasMany - (voucherToEdit?.hasMany || 0)
    let partnerName = voucherToEdit?.Partner?.fantasyName || partners.chosen.fantasyName
    let randomCodes = generateRandomCodes(codesToAdd, partnerName.trim().substr(0, 1), CSV || [])
    let description = data.description.toString('html')
    let image =
      data.image instanceof File ? await ImageUploadToS3(data.image, 'voucher/image/') : data.image
    const csv =
      data.type === 1
        ? data.random === 0
          ? data.couponsCode?.length > 0
            ? await uploadCouponsCode()
            : data.csv
          : codesToAdd > 0
            ? await uploadCouponsCode(randomCodes)
            : data.csv
        : ''
    const code = data.type === 1 ? undefined : data.code
    const couponsCode = {
      1: {
        0: data.couponsCode,
        1: randomCodes
      }[data.random],
      2: undefined
    }[data.type]
    const couponsBook = data.couponsBook.map((book, index) => ({
      ...book,
      offer: book.offer || '0',
      codesToAdd:
        book.hasMany -
        (voucherToEdit?.CouponsBookOffers?.find(book2 => Number(book2.offer) === Number(book.offer))
          ?.hasMany || 0),
      shouldAppearOnLP: ~~(data.shouldAppearOnLP === index),
      rules: book.rules.toString('html')
    }))

    await addOrEditVoucher({
      ...data,
      situation,
      description,
      image,
      csv,
      code,
      couponsCode,
      couponsBook,
      hasMany,
      codesToAdd
    })
    setLoading(false)
    setShowLoadingModal(false)

    history.push('/voucherlist')
  }

  const publish = () => save(1)
  const saveAsDraft = () => save(3)

  const exclude = async () => {
    setLoading(true)
    setShowLoadingModal(true)
    await addOrEditVoucher({
      id: data.id,
      situation: 2,
      couponsBook: voucherToEdit.CouponsBookOffers
    })
    setLoading(false)
    setShowLoadingModal(false)
    history.push('/voucherlist')
  }

  const toolbarConfig = {
    display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS'],
    INLINE_STYLE_BUTTONS: [
      { label: 'Bold', style: 'BOLD' },
      { label: 'Italic', style: 'ITALIC' }
    ],
    BLOCK_TYPE_BUTTONS: [
      { label: 'UL', style: 'unordered-list-item' },
      { label: 'OL', style: 'ordered-list-item' }
    ]
  }

  return (
    <>
      <div className={classes.outerContainer}>
        {loading || loadingCSV ? <LinearProgress /> : null}
        <div className={classes.content}>
          <div className={classes.main}>
            <div className={clsx(classes.inputGroup, classes.fullRowTwoColumns)}>
              <span>Título do cupom</span>
              <input
                value={data.title}
                onChange={e =>
                  setDataIfPossible({
                    title: e.target.value
                  })
                }
              />
            </div>
            <div className={classes.inputGroup}>
              <span>Parceiro</span>
              <input
                value={partners.query}
                onFocus={() => setPartnersInfo({ showOptions: true })}
                onChange={e => getPartners(e.target.value)}
              />
              {partners.showOptions && (
                <MenuList className={classes.menuList}>
                  {partners.loading && <MenuItem disabled>Pesquisando...</MenuItem>}
                  {!partners.loading && partners.data.length === 0 && (
                    <MenuItem disabled>
                      {partners.query.trim().length < 4
                        ? 'Pesquise um termo'
                        : 'Nenhum resultado encontrado'}
                    </MenuItem>
                  )}
                  {partners.data.map(partner => (
                    <MenuItem key={partner.id} onClick={() => selectPartner(partner)}>
                      {partner.fantasyName}
                    </MenuItem>
                  ))}
                </MenuList>
              )}
            </div>
            <div className={classes.inputGroup}>
              <span>Valor do cupom</span>
              <input
                value={new Intl.NumberFormat('pt-br', {
                  style: 'currency',
                  currencyDisplay: 'symbol',
                  currency: 'BRL',
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                }).format(data.value)}
                onChange={e =>
                  setDataIfPossible({
                    value: Number(e.target.value.replace(/\D/g, '')) / 100
                  })
                }
              />
            </div>
            <div className={classes.inputGroup}>
              <span>Tipo de cupom</span>
              <select
                value={data.type}
                onChange={e =>
                  setDataIfPossible({
                    type: Number(e.target.value)
                  })
                }
                disabled={voucherToEdit}
              >
                <option value={1}>Lista de cupons</option>
                <option value={2}>Código único</option>
              </select>
            </div>
            {data.type === 1 && (
              <div className={classes.inputGroup}>
                <span>Upload de CSV</span>
                <div>
                  <FormControlLabel
                    className={classes.checkboxLabel}
                    checked={!!data.random}
                    onChange={e =>
                      setDataIfPossible({
                        random: Number(e.target.checked)
                      })
                    }
                    control={<Checkbox className={clsx(!voucherToEdit && classes.checkbox)} />}
                    label="Gerar automaticamente"
                    disabled={voucherToEdit}
                  />
                  <span className={classes.spacer} />
                  {data.random === 0 && (
                    <label>
                      <span className={classes.plainButton2}>Selecionar arquivo</span>
                      <input
                        className={classes.hiddenInput}
                        type="file"
                        accept="text/csv"
                        onChange={e => setCouponsCode(e.target.files[0])}
                      />
                    </label>
                  )}
                </div>
              </div>
            )}
            {data.type === 2 && (
              <div className={classes.inputGroup}>
                <span>Código</span>
                <input
                  value={data.code}
                  onChange={e =>
                    setDataIfPossible({
                      code: e.target.value
                    })
                  }
                  disabled={voucherToEdit}
                />
              </div>
            )}
            <div className={classes.inputGroup}>
              <span>Quantidade disponível</span>
              <input
                value={data.type === 1 && data.random === 0 ? hasManyType1 : data.hasMany}
                onChange={e =>
                  setDataIfPossible({
                    hasMany: Number(e.target.value.replace(/\D/g, ''))
                  })
                }
                disabled={data.type === 1 && data.random === 0}
              />
            </div>
            <div className={clsx(classes.inputGroup, classes.dateInputGroup)}>
              <span>Data de validade</span>
              <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="pt-br">
                <DatePicker
                  format="L"
                  value={data.validDate}
                  onChange={mmt =>
                    setDataIfPossible({
                      validDate: mmt.format('YYYY-MM-DD')
                    })
                  }
                  minDate={voucherToEdit?.validDate || moment().add(1, 'day').format('YYYY-MM-DD')}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className={clsx(classes.inputGroup, classes.fullRowTwoColumns)}>
              <span>Descrição</span>
              <div style={{ height: 'unset' }}>
                <RTE
                  className={classes.rte}
                  value={data.description}
                  onChange={value =>
                    setDataIfPossible({
                      description: value
                    })
                  }
                  toolbarConfig={toolbarConfig}
                />
              </div>
            </div>
            <div className={clsx(classes.divider, classes.fullRowTwoColumns)} />
            <h4 className={clsx(classes.subtitle, classes.fullRowTwoColumns)}>
              Ofertas associadas [Opcional]
            </h4>
            {data.couponsBook.map((book, index, { length }) => (
              <div key={index} className={clsx(classes.group, classes.fullRowTwoColumns)}>
                <div className={clsx(classes.inputGroup, classes.fullRowTwoColumns)}>
                  <span>ID da oferta</span>
                  <input
                    value={book.offer}
                    onChange={e => setCouponBookField(index, 'offer', e.target.value)}
                    disabled={voucherToEdit?.CouponsBookOffers?.length > index}
                    placeholder="Deixar em branco para geral"
                  />
                </div>
                <div className={classes.inputGroup}>
                  <span>Estoque da oferta</span>
                  <input
                    value={book.hasMany}
                    onChange={e =>
                      setCouponBookField(
                        index,
                        'hasMany',
                        Number(e.target.value.replace(/\D/g, ''))
                      )
                    }
                  />
                </div>
                <div className={classes.inputGroup}>
                  <span>Limite por usuário</span>
                  <input
                    value={book.userLimit}
                    onChange={e =>
                      setCouponBookField(
                        index,
                        'userLimit',
                        Number(e.target.value.replace(/\D/g, ''))
                      )
                    }
                  />
                </div>
                <div className={classes.inputGroup}>
                  <span>Forma de ativação</span>
                  <select
                    value={book.activationType}
                    onChange={e => setCouponBookField(index, 'activationType', e.target.value)}
                    disabled={voucherToEdit?.CouponsBookOffers?.length > index}
                  >
                    <option value={1}>Automática</option>
                    <option value={2}>Manual</option>
                  </select>
                </div>
                <div className={classes.inputGroup} disabled={book.activationType === 1}>
                  <span>Tempo de expiração [h]</span>
                  <input
                    value={book.expirationTime}
                    onChange={e =>
                      setCouponBookField(
                        index,
                        'expirationTime',
                        Number(e.target.value.replace(/\D/g, ''))
                      )
                    }
                    disabled={book.activationType === 1}
                  />
                </div>
                <div className={classes.inputGroup}>
                  <span>Texto do CTA</span>
                  <input
                    value={book.ctaText}
                    onChange={e => setCouponBookField(index, 'ctaText', e.target.value)}
                  />
                </div>
                <div className={classes.inputGroup}>
                  <span>Link do CTA</span>
                  <input
                    value={book.ctaLink}
                    onChange={e => setCouponBookField(index, 'ctaLink', e.target.value)}
                  />
                </div>
                <div className={clsx(classes.inputGroup, classes.dateInputGroup)}>
                  <span>Data de lançamento</span>
                  <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="pt-br">
                    <DatePicker
                      format="L"
                      value={book.launchDate}
                      onChange={mmt =>
                        setCouponBookField(index, 'launchDate', mmt.format('YYYY-MM-DD'))
                      }
                      maxDate={moment(data.validDate).subtract(1, 'day').format('YYYY-MM-DD')}
                      maxDateMessage=""
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div className={classes.inputGroup}>
                  <span>Deve aparecer na LP?</span>
                  <div>
                    <FormControlLabel
                      className={classes.checkboxLabel}
                      checked={data.shouldAppearOnLP === index}
                      onChange={() =>
                        setDataIfPossible({
                          shouldAppearOnLP: data.shouldAppearOnLP === index ? null : index
                        })
                      }
                      control={<Checkbox className={classes.checkbox} />}
                    />
                  </div>
                </div>
                <div className={clsx(classes.inputGroup, classes.fullRowTwoColumns)}>
                  <span>Regras de uso</span>
                  <div style={{ height: 'unset' }}>
                    <RTE
                      className={classes.rte}
                      value={book.rules}
                      onChange={value => setCouponBookField(index, 'rules', value)}
                      toolbarConfig={toolbarConfig}
                    />
                  </div>
                </div>
                {length > 1 &&
                  (!voucherToEdit || voucherToEdit.CouponsBookOffers.length < index + 1) && (
                    <>
                      <div className={clsx(classes.divider2, classes.fullRowTwoColumns)} />
                      <button
                        className={clsx(
                          classes.plainButton,
                          classes.plainButtonRed,
                          classes.fullRowTwoColumns,
                          classes.end
                        )}
                        type="button"
                        onClick={() => excludeCouponBook(index)}
                      >
                        Excluir regra
                      </button>
                    </>
                  )}
              </div>
            ))}
            <div
              className={clsx(classes.addButton, classes.fullRowTwoColumns)}
              onClick={addCouponBook}
            >
              <AddIcon />
              Adicionar regra de oferta
            </div>
          </div>
          <div className={classes.aside}>
            <div className={clsx(classes.box, classes.fullRowTwoColumns)}>
              <h4>Imagem destacada</h4>
              <div>
                <label>
                  {data.image ? (
                    <img
                      className={classes.img}
                      src={
                        data.image instanceof File
                          ? URL.createObjectURL(data.image)
                          : REACT_APP_IMAGES_URL + data.image
                      }
                    />
                  ) : null}
                  <span className={classes.plainButton}>Selecionar arquivo</span>
                  <input
                    className={classes.hiddenInput}
                    type="file"
                    accept="image/png,image/jpeg,image/gif"
                    onChange={e =>
                      setDataIfPossible({
                        image: e.target.files[0]
                      })
                    }
                  />
                </label>
                <span className={classes.legend}>Arquivo .png, .jpg ou .gif</span>
              </div>
            </div>
            <div className={clsx(classes.link, classes.fullRowTwoColumns)}>
              <a
                href="https://docs.google.com/spreadsheets/d/1ZTnot0TVZgbTCBVAtZAj-JgkEgYWX2zhS4aH9a106gY/edit?usp=sharing"
                target="_blank"
                rel="noreferrer noopener"
              >
                Ver modelo .CSV
              </a>
            </div>
            {voucherToEdit && (
              <button
                className={clsx(classes.plainButton, classes.plainButtonRed)}
                type="button"
                onClick={showExcludeModal}
              >
                Suspender cupom
              </button>
            )}
            {!voucherToEdit && (
              <button
                className={clsx(classes.plainButton, classes.plainButtonLilac)}
                type="button"
                onClick={saveAsDraft}
              >
                Salvar rascunho
              </button>
            )}
            <button className={classes.shadowButton} type="button" onClick={publish}>
              {voucherToEdit?.situation === 1 ? 'Salvar' : 'Publicar'}
            </button>
            {voucherToEdit?.situation === 3 && (
              <button
                className={clsx(classes.plainButton, classes.plainButtonLilac)}
                type="button"
                onClick={saveAsDraft}
              >
                Salvar rascunho
              </button>
            )}
          </div>
        </div>
      </div>

      <Dialog
        open={!!errors}
        onClose={hideErrorsModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Erros encontrados</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Encontramos os seguintes erros:
            <ul>
              {errors?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            Corrija-os antes de prosseguir.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={hideErrorsModal}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={shouldExclude} onClose={hideExcludeModal}>
        <DialogTitle>Excluir</DialogTitle>
        <DialogContent>
          <DialogContentText>Deseja suspender o bloco?</DialogContentText>
          <DialogContentText>A ação não pode ser desfeita.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={hideExcludeModal}>
            Não
          </Button>
          <Button color="primary" onClick={exclude}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <ToastMessages />
    </>
  )
}

const useStyles = makeStyles({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat',
    fontWeight: '500',
    '& label': {
      margin: '0 !important'
    }
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '45px'
  },
  main: {
    flexGrow: 1,
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    marginRight: 30,
    gap: '30px'
  },
  group: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    alignItems: 'end',
    padding: '30px',
    gap: '20px 30px',
    backgroundColor: '#ece5fe',
    borderRadius: '4px'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    '& > span': {
      fontSize: '16px',
      fontWeight: 700,
      color: '#30287b'
    },
    '& > input, & > div, & textarea, & select': {
      marginTop: '10px',
      background: '#fff',
      border: '2px solid #30287b !important',
      '&[disabled]': {
        opacity: 1,
        background: '#0000000a'
      }
    },
    '& input, & textarea, & select': {
      padding: '11px 13px',
      fontSize: '14px',
      color: '#30287b',
      border: 'none'
    },
    '& > div': {
      display: 'flex',
      flexDirection: 'row'
    },
    '& > div input, & > div select': {
      flexGrow: 1,
      height: '100%'
    },
    '& > input, & > div, & select': {
      height: 44
    },
    '& textarea': {
      minHeight: 132,
      resize: 'none'
    }
  },
  dateInputGroup: {
    width: '100%',
    '& *::before': {
      display: 'none !important'
    },
    '& *::after': {
      display: 'none !important'
    }
  },
  divider: {
    marginTop: '15px',
    borderBottom: '2px solid #b294ff'
  },
  divider2: {
    margin: '10px -30px',
    borderBottom: '2px solid #b294ff'
  },
  subtitle: {
    margin: '15px 0 0',
    fontFamily: 'Matrice',
    fontSize: '18px',
    color: '#30287b'
  },
  aside: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, auto)',
    width: '30%',
    minWidth: 340,
    gap: '15px'
  },
  fullRowTwoColumns: {
    gridColumn: '1 / 3'
  },
  box: {
    border: '2px solid #30287b',
    '& h4': {
      marginBottom: 0,
      fontSize: '14px',
      fontWeight: '700',
      color: '#ffffff',
      lineHeight: '44px',
      textAlign: 'center',
      textTransform: 'uppercase',
      background: '#30287b',
      borderBottom: '2px solid #30287b'
    },
    '& > div': {
      display: 'grid',
      gridTemplateColumns: 'auto',
      gap: '15px',
      padding: '30px'
    }
  },
  plainButton: {
    display: 'block',
    width: '100%',
    margin: '0',
    padding: '0 20px',
    fontSize: '12px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '44px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#ece5fe',
    border: 'none',
    borderRadius: '2px',
    cursor: 'pointer'
  },
  plainButton2: {
    display: 'block',
    margin: '2px',
    padding: '6px 5px',
    fontSize: '11px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '24px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#ece5fe',
    border: 'none',
    borderRadius: '2px',
    cursor: 'pointer'
  },
  plainButtonRed: {
    color: '#fff',
    background: '#d73f32'
  },
  plainButtonLilac: {
    color: '#30287b',
    background: '#ece5fe'
  },
  shadowButton: {
    width: '100%',
    fontSize: '12px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '44px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#fbbb33',
    border: 'none',
    borderRadius: '2px',
    boxShadow: '4px 4px #4200f5',
    cursor: 'pointer'
  },
  img: {
    width: '100%',
    height: 'auto'
  },
  hiddenInput: {
    visibility: 'hidden',
    opacity: 0,
    position: 'absolute',
    width: 0,
    height: 0,
    margin: 0,
    padding: 0
  },
  legend: {
    fontSize: '12px',
    fontStyle: 'italic',
    color: '#30287b',
    textAlign: 'center'
  },
  end: {
    justifySelf: 'end',
    width: 'fit-content'
  },
  addButton: {
    justifySelf: 'center',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '11px 15px',
    fontSize: '12px',
    fontWeight: 700,
    color: '#30287b',
    lineHeight: '15px',
    textTransform: 'uppercase',
    border: '2px solid #30287b',
    borderRadius: 4,
    cursor: 'pointer',
    '& svg': {
      marginRight: '6px',
      fontSize: '18px'
    }
  },
  menuList: {
    position: 'absolute',
    width: '100%',
    top: '100%',
    left: 0,
    background: '#ece5fe',
    zIndex: 10
  },
  link: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '44px',
    textAlign: 'center',
    background: '#ece5fe',
    '& a': {
      color: 'inherit'
    }
  },
  rte: {
    width: '100%',
    minHeight: 140,
    border: 'none'
  },
  checkboxLabel: {
    color: '#30287b'
  },
  checkbox: {
    color: '#30287b !important'
  },
  spacer: {
    flexGrow: 1
  }
})

export default VoucherForm
